import AiAgentAsCsFilesList from '../../../../../components/units/Management/AiAgent/AsCs/Files';

export default function AiAgentAsCsFileListPage() {
  return <AiAgentAsCsFilesList />;
}
